import styled, { keyframes } from 'styled-components'

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

export const Root = styled.a`
  display: block;
  position: relative;
  width: 100%;
  overflow: hidden;
  overflow: clip;
  clip-path: inset(0);
  contain: layout paint;
  text-decoration: none;
  background: ${p => p.bg};
  color: ${p => p.color};
  height: 50px;

  ${p => p.theme.mq.upMd} {
    height: 66px;
  }
`

export const Track = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: max-content;
  height: 100%;
  align-items: center;
  animation: ${scroll} var(--text-line-duration, 30s) linear infinite;
  will-change: transform;
`

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-right: 20px;
  flex-shrink: 0;

  ${p => p.theme.mq.upMd} {
    gap: 40px;
    padding-right: 40px;
  }

  ${p => p.theme.mq.upLg} {
    gap: 50px;
    padding-right: 50px;
  }
`

export const TextItem = styled.span`
  flex-shrink: 0;
  font-family: ${p => p.theme.typography.baseFont};
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;

  ${p => p.theme.mq.upLg} {
    font-size: 18px;
  }
`

export const FixedTextItem = styled(TextItem)`
  ${p => p.theme.mq.upLg} {
    font-size: 16px;
  }
`

export const LegacyItem = styled.div`
  display: flex;
  align-items: center;
  padding-right: ${p => p.padding}px;
  flex-shrink: 0;
`

export const LegacyContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${p => p.theme.typography.baseFont};
  font-size: 14px;
  font-weight: 700;
  color: ${p => p.color};

  ${p => p.theme.mq.upLg} {
    font-size: 18px;
  }
`

export const LegacyImg = styled.img`
  max-width: ${p => p.imgSize ? (typeof p.imgSize === 'number' ? `${p.imgSize}px` : p.imgSize) : 'auto'};
`

/**
 * Иконка "2 Полных генома" — цельная картинка двух тест-боксов.
 */
export const TestBoxesIcon = styled.div`
  width: 65px;
  height: 48px;
  flex-shrink: 0;
  background-image: url('/static/images/banner-genom/boxes.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${p => p.theme.mq.upMd} {
    width: 90px;
    height: 66px;
  }
`

/**
 * Иконка "Macbook" — цельная картинка макбука с экраном дашборда.
 */
export const MacbookIcon = styled.div`
  width: 60px;
  height: 36px;
  flex-shrink: 0;
  background-image: url('/static/images/banner-genom/macbook-full.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${p => p.theme.mq.upMd} {
    width: 76px;
    height: 46px;
  }
`

export const BundleTestsIcon = styled.div`
  width: 72px;
  height: 50px;
  flex-shrink: 0;
  background-image: url('/static/images/banner-bundle/text-line-tests.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${p => p.theme.mq.upMd} {
    width: 87px;
    height: 60px;
  }
`

export const GiftIcon = styled.div`
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  background-image: url('/static/images/banner-bundle/text-line-gift.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${p => p.theme.mq.upMd} {
    width: 40px;
    height: 40px;
  }
`

export const StartMoleculeIcon = styled.div`
  width: 62px;
  height: 60px;
  flex-shrink: 0;
  background-image: url('/static/images/banner-bundle/text-line-start.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`
